import { Dialog, Table } from "../../../layout";
import { Avatar, Divider } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ViewSale from "./ViewSale/ViewSale";
import Filter from "./Filter";
import { AppContext } from "../../../App";
import { action, API, controller } from "../../../api/api";
import TopHeader from "./TopHeader";
import { RmvEmptyProp, ToFormData, useFormatPrice } from "hooks";
import moment from "moment";
import { useParams } from "react-router-dom";
import SaleAction from "./SaleAction";
import StatusWidget from "./StatusWidget";

const SalesHistory = () => {
  const { customerId } = useParams();
  const { setLoader } = useContext(AppContext);
  const formatPrice = useFormatPrice();

  const [viewSale, setViewSale] = useState(false);
  const [sells, setSells] = useState([]);
  const [viewData, setViewData] = useState();
  const [searchTerm, setSearchTerm] = useState({
    customerId: parseInt(customerId) || "",
    saleType: 1,
    fromDate: "",
    toDate: "",
  });

  useEffect(() => {
    setLoader(true);
    API(controller.Sell + action.FilterSales).post(
      ToFormData(RmvEmptyProp(searchTerm)),
      (res) => {
        res && res.status === 200 && setSells([...res.result]);
        setLoader(false);
      }
    );
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTerm]);

  const handleView = (item) => {
    setViewData(item);
    setViewSale(true);
  };

  return (
    <>
      <TopHeader {...{ setSearchTerm, searchTerm }} />

      <Table
        onClick={(item) => handleView(item)}
        ActionComp={(item) => <SaleAction {...{ item, handleView }} />}
        HeaderComp={() => <Filter {...{ setSearchTerm, searchTerm }} />}
        tblHead={[
          { id: "actions", label: "Actions" },
          { id: "statusName", label: "Status" },
          { id: "receipt", label: "Receipt" },
          { id: "cstmr", label: "Customer" },
          { id: "soldBy", label: "Sold by	" },
          { id: "amt", label: "Sale Total" },
          { id: "note", label: "Note" },
        ]}
        tblData={sells.map((item) => {
          var customer = item.customer;
          var user = item.sellUser;
          var outlet = item.sellReg && item.sellReg.outlet;
          return {
            ...item,
            statusSearchTerm: item.statusName,
            statusName: (
              <StatusWidget
                {...{
                  status: item.status,
                  name: item.statusName,
                  type: item.type,
                  didReturn: item.didReturn,
                }}
              />
            ),
            note: item.note ? item.note : "-",
            amt: (
              <div className="w-fit">
                <span className="text-gray-500 text-[15px]">
                  Net Payable: {formatPrice(item?.netPayable)}
                </span>
                {item.status === 1 && (
                  <>
                    <Divider />
                    <span className="text-[15px] text-red-500 font-medium">
                      Due: {formatPrice(item?.netPayable - item.received)}
                    </span>
                  </>
                )}
              </div>
            ),
            receipt: (
              <div className="grid">
                <span className="font-medium">{item.id}</span>
                <span className="text-[12px]">
                  {item.sellDate &&
                    moment(item.sellDate).format("MMM  DD, YYYY, h:mm A")}
                </span>
              </div>
            ),
            cstmr: customer ? (
              <div className="flex gap-[10px] items-center mb-[5px] mt-[5px]">
                <Avatar
                  className="bg-primary"
                  alt={customer.firstName}
                  src={customer.photo}
                >
                  {(customer.firstName + customer.lastName)
                    .toUpperCase()
                    .slice(0, 2)}
                </Avatar>
                <div className="grid">
                  <span className="">{`${customer.firstName} ${customer.firstName}`}</span>
                  <div className="flex gap-1">
                    <span className="text-[12px] font-medium">
                      {customer.cstmrCode}
                    </span>
                    {customer.email && (
                      <>
                        <span className="text-[12px] font-bold">|</span>
                        <a
                          className="text-[12px] underline hover:text-primary !hover:font-bold"
                          href={`mailto:${customer.email}`}
                        >
                          {customer.email}
                        </a>
                      </>
                    )}
                  </div>
                </div>
              </div>
            ) : (
              "-"
            ),
            soldBy: user ? (
              <div className="flex gap-[15px] items-center mb-[5px] mt-[5px]">
                <Avatar className="bg-primary" src={user.photo}>
                  {" "}
                  {(user?.fullName).toUpperCase().slice(0, 2)}
                </Avatar>
                <div className="grid">
                  <span className="">{user?.fullName}</span>
                  <span className="text-[12px]">
                    {outlet && outlet.outletName}
                  </span>
                </div>
              </div>
            ) : (
              "-"
            ),
          };
        })}
      />

      {viewSale && (
        <Dialog show={viewSale} onClose={false} maxWidth="md">
          <ViewSale
            {...{
              id: viewData.id,
              setShowForm: setViewSale,
              handleView,
              setSells,
            }}
          />
        </Dialog>
      )}
    </>
  );
};

export default SalesHistory;
